import React from 'react';
import gql from 'graphql-tag';
import { MutationFn } from 'react-apollo';
import { useMutation } from '@reverbdotcom/commons/src/useMutation';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { DeleteMyFavorite } from '@reverbdotcom/commons/src/rql';

export type DeleteMyFavoriteMutationFn = MutationFn<DeleteMyFavorite.Mutation, DeleteMyFavorite.Variables>;

const mutationFnName = 'deleteMyFavorite';
type EmptyObject = Record<string, never>;

export const DELETE_FAVORITE_MUTATION = gql`
  mutation DeleteMyFavorite($input: Input_core_apimessages_DeleteMyFavoriteRequest) {
    deleteMyFavorite(input: $input) {
      favorite {
        id
        favorited
      }
    }
  }
`;

export const withDeleteMyFavoriteMutation =
  withGraphql<EmptyObject, DeleteMyFavorite.Mutation, DeleteMyFavorite.Variables>(
    DELETE_FAVORITE_MUTATION,
    {
      name: mutationFnName,
    },
  );

export interface DeleteMyFavoriteState {
  deleteMyFavorite: () => any;
}

export function useDeleteMyFavorite(
  deleteMyFavorite: DeleteMyFavoriteMutationFn,
  id: string,
  queryToBeRefetchedName?: string,
): DeleteMyFavoriteState {
  const [mutate] = useMutation(deleteMyFavorite);

  const deleteMyFavoriteCallback = React.useCallback(async function () {
    return mutate({
      variables: {
        input: {
          id,
        },
      },
      optimisticResponse: {
        __typename: 'Mutation',
        deleteMyFavorite: {
          __typename: 'core_apimessages_DeleteMyFavoriteResponse',
          favorite: {
            __typename: 'core_apimessages_Favorite',
            id,
            favorited: false,
          },
        },
      },
      refetchQueries: queryToBeRefetchedName ? [queryToBeRefetchedName] : null,
      awaitRefetchQueries: !!queryToBeRefetchedName,
    });
  }, [id, queryToBeRefetchedName, mutate]);

  return { deleteMyFavorite: deleteMyFavoriteCallback };
}
